<template>
  <div class="card card-stats">
    <div class="card-header">
      <slot name="header">
        <div class="row">
          <div class="icon-big col-5 col-md-4 text-center">
            <i :class="icon"></i>
          </div>
          <div class="col-7 col-md-8 text-right">
            <p class="card-category"> {{ $t('departure_statistics.currently_driven_departures') }} </p>
          </div>
        </div>
        <hr class="custom-hr"/>
      </slot>
    </div>
    <div class="card-body" v-for="(stat, index) in currentlyDrivenDepartureStatisticsList" :key="index">
      <div class="row">
        <div class="col-8">{{stat[0]}}</div>
        <div class="col-4 text-right">{{stat[1]}}</div>
      </div>
    </div>
    <div class="card-footer" v-if="updatedAt">
      <hr/>
      <slot name="footer"><i class="nc-icon nc-refresh-69"></i> {{$t('overview.updated')}} {{updatedAt}}</slot>
    </div>
  </div>
</template>

<script>
import statistics from '@/store/system/statistics';
import moment from 'moment';

export default {
  name: 'departure-statistics-card',
  data() {
    return {
      updatedAt: "",
      icon: "nc-icon nc-bus-front-12",
      departureStatisticsInterval: null,
      currentlyDrivenDepartureStatisticsList: [
        {0: '...', 1: '...'},
        {0: '...', 1: '...'},
        {0: '...', 1: '...'}
      ]
    }
  },
  created() {
    if (!this.$store.state.statistics) {
        this.$store.registerModule("statistics" , statistics);
    }
    this.$store.dispatch('statistics/getCurrentlyDrivenDepartureStatistics');
    this.departureStatisticsInterval = setInterval(() => {
      this.$store.dispatch('statistics/getCurrentlyDrivenDepartureStatistics');
    }, 30000);
  },
  beforeDestroy() {
    if(this.departureStatisticsInterval != null) {
      clearInterval(this.departureStatisticsInterval);
    }
  },
  computed: {
    currentlyDrivenDepartureStatistics() {
      if (!this.$store.state.statistics) {
        this.$store.registerModule("statistics" , statistics);
    }
      return this.$store.state.statistics.currentlyDrivenDepartureStatistics;
    }
  },
  methods: {
    updateStatisticsList(listWithStatistics) {
      if(!Array.isArray(listWithStatistics) || listWithStatistics.length <= 0) {
        console.error("Can't update statistics list.");
        return
      }
      let resultArray = [];
      let withVehicle = 0;
      let withoutVehicle = 0;
      try {
        listWithStatistics.forEach((stat) => {
          if(stat[0] == 'WITHOUT_VEHICLE') {
            resultArray.push( {0: this.$t('departure_statistics.without_vehicles'), 1: stat[1]} );
            withoutVehicle = stat[1];
          } else if (stat[0] == 'WITH_VEHICLE') {
            resultArray.push( {0: this.$t('departure_statistics.with_vehicles'), 1: stat[1]} );
            withVehicle = stat[1];
          }
        });
        const totalVehicles = withVehicle + withoutVehicle;
        if(totalVehicles > 0) {
          resultArray.push( {0: this.$t('departure_statistics.total'), 1: totalVehicles} );
        }
        this.currentlyDrivenDepartureStatisticsList = resultArray;
        this.updateTime();
      } catch (error) {
        console.error(error);
      }
    },
    updateTime() {
      this.updatedAt = moment().format("DD.MM.YYYY HH:mm");
    }
  },
  watch: {
    currentlyDrivenDepartureStatistics: {
      deep: true,
      handler: function (newValue) {
        this.updateStatisticsList(newValue);
      }
    }
  }
}
</script>
<style scoped lang="scss">

.card-stats.link {
   cursor: pointer;
}

hr.solid {
  border-top: 2px solid #ddd;
  border-radius: 5px;
  margin-bottom: 2rem;
 
}

.custom-hr {
  margin-top: 0rem;
  margin-bottom: 0rem;
}

.card-content{
  min-height: 85px
}
</style>